import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "pt-24 -md:pt-16" }
const _hoisted_2 = { class: "px-6 py-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title text-left pb-5" }, "Volumetria", -1)
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = {
  key: 0,
  class: "flex h-full w-full flex-col items-center justify-start"
}
const _hoisted_6 = { class: "grid grid-cols-12 gap-x-4 gap-y-2 -lg:flex -lg:flex-col" }
const _hoisted_7 = { class: "col-span-6 -lg:flex -lg:flex-col" }
const _hoisted_8 = {
  key: 0,
  class: "col-span-12 grid grid-cols-12 gap-x-4 gap-y-2 -lg:flex -lg:flex-col"
}
const _hoisted_9 = { class: "grid col-span-6 grid-cols-12 -lg:flex -lg:flex-col" }
const _hoisted_10 = { class: "col-span-4 grid grid-cols-12 w-full gap-4 -lg:flex -lg:flex-col" }
const _hoisted_11 = { class: "col-span-2 flex h-full w-full items-center justify-end -lg:h-16" }
const _hoisted_12 = {
  key: 1,
  class: "flex h-full w-full flex-col items-center justify-start"
}
const _hoisted_13 = { class: "grid grid-cols-12 gap-x-4 gap-y-2 -lg:flex -lg:flex-col" }
const _hoisted_14 = { class: "grid col-span-6 grid-cols-12 -lg:flex -lg:flex-col" }
const _hoisted_15 = { class: "col-span-4 grid grid-cols-12 w-full gap-4 -lg:flex -lg:flex-col" }
const _hoisted_16 = { class: "col-span-2 flex h-full w-full items-center justify-end -lg:h-16" }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "grid grid-cols-12 xl:grid-cols-10 gap-2 pb-5" }
const _hoisted_19 = { class: "h-full flex flex-col justify-around items-center w-full p-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-brand text-xl" }, " Total ", -1)
const _hoisted_21 = { class: "flex justify-center items-center" }
const _hoisted_22 = { class: "font-bold text-3xl text-gray-600" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-xs" }, " Total de estabelecimentos comerciais ", -1)
const _hoisted_24 = { class: "h-full flex flex-col justify-around items-center w-full p-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-brand text-xl" }, " Transações ", -1)
const _hoisted_26 = { class: "flex justify-center items-center" }
const _hoisted_27 = { class: "font-bold text-3xl text-gray-600" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-xs" }, " Total de transações realizadas ", -1)
const _hoisted_29 = { class: "h-full flex flex-col justify-around items-center w-full p-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-brand text-xl" }, " Receita ", -1)
const _hoisted_31 = { class: "flex justify-center items-center" }
const _hoisted_32 = { class: "font-bold text-3xl text-gray-600" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-xs" }, " Valor gerado em taxa por transação ", -1)
const _hoisted_34 = { class: "h-full flex flex-col justify-around items-center w-full p-2" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-brand text-xl" }, " Despesa ", -1)
const _hoisted_36 = { class: "flex justify-center items-center" }
const _hoisted_37 = { class: "font-bold text-3xl text-gray-600" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-xs" }, " Valor cobrado em taxa por transação ", -1)
const _hoisted_39 = { class: "h-full flex flex-col justify-around items-center w-full p-2" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-brand text-xl" }, " Balanço ", -1)
const _hoisted_41 = { class: "flex justify-center items-center" }
const _hoisted_42 = { class: "font-bold text-3xl text-gray-600" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-xs" }, " Receita menos despesas das transações ", -1)
const _hoisted_44 = { class: "flex flex-col mt-3" }
const _hoisted_45 = { class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_46 = { class: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" }
const _hoisted_47 = { class: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg p-2" }
const _hoisted_48 = {
  key: 0,
  class: "flex flex-col mt-3"
}
const _hoisted_49 = /*#__PURE__*/_createStaticVNode("<div class=\"-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8\"><div class=\"py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8\"><div class=\"overflow-hidden sm:rounded-lg p-2\"><p class=\"text-xs\"><span class=\"font-bold\">Taxa atual da EC *:</span> Taxa aplicada a cada transação do estabelecimento. Note que, no intervalo selecionado, pode haver transações com taxas diferentes. Verifique a planilha detalhada para mais informações. </p><p class=\"text-xs\"><span class=\"font-bold\">Taxa atual da SH *:</span> Taxa aplicada a cada transação da SH. Note que, no intervalo selecionado, pode haver transações com taxas diferentes. Verifique a planilha detalhada para mais informações. </p></div></div></div>", 1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = {
  key: 0,
  class: "col-span-10 flex h-full w-full items-center justify-end gap-4 mt-5"
}
const _hoisted_52 = {
  key: 3,
  class: "shadow overflow-hidden flex flex-col items-center justify-center border-b border-gray-200 bg-gray-50 sm:rounded-lg w-full h-60"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("embed", {
  width: "50",
  height: "50",
  src: "/colorful-loading.gif",
  class: "m-auto"
}, null, -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = { class: "w-8/10 max-w-2xl bg-white m-auto rounded-lg p-3 z-50" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "text-black text-2xl" }, " Relatório de volumetria ", -1)
const _hoisted_57 = { class: "my-3 text-base" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("p", { class: "my-3 text-base" }, "Escolha o tipo de relatório que você deseja e clique no botão para gerar o relatório:", -1)
const _hoisted_59 = { class: "flex items-center mt-4 h-full w-full justify-end" }
const _hoisted_60 = ["hidden"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomInputAutocomplete = _resolveComponent("CustomInputAutocomplete")!
  const _component_CustomInput = _resolveComponent("CustomInput")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Form = _resolveComponent("Form")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isRoot)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_Form, { class: "mt-1 !space-y-0" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_CustomInputAutocomplete, {
                        label: "Software house *",
                        class: "z-20 col-span-12",
                        searchValue: !_ctx.loadingSoftwareHouses ? _ctx.searchSoftwareHouseText : 'Carregando...',
                        searchFunction: () => (_ctx.softwareHouses = _ctx.searchSoftwareHouses()),
                        delay: 0,
                        disabled: _ctx.loadingSoftwareHouses,
                        minimumCharactersToShowList: 0,
                        listValues: 
                    _ctx.softwareHouses.map(({ nomeFantasia, razaoSocial, cnpj }) => {
                      return {
                        primaryText: nomeFantasia ? nomeFantasia : razaoSocial,
                        secondaryText: `${
                          cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
                        } | ${razaoSocial}`,
                        id: cnpj,
                      };
                    })
                  ,
                        inputEvent: "update:input",
                        resultEvent: "update:select",
                        isIncorrect: _ctx.isSoftwareHouseIncorrect,
                        incorrectMessage: "Campo obrigatório!",
                        "onUpdate:input": _ctx.updateSearchSoftwareHouseText,
                        "onUpdate:select": _ctx.selectSoftwareHouse
                      }, null, 8, ["searchValue", "searchFunction", "disabled", "listValues", "isIncorrect", "onUpdate:input", "onUpdate:select"])
                    ]),
                    (_ctx.softwareHouseSelected)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_CustomInputAutocomplete, {
                              label: "Estabelecimentos",
                              class: "z-10 col-span-12",
                              searchValue: _ctx.searchEstabelecimentoText,
                              searchFunction: () => (_ctx.estabelecimentosAutoComplete = _ctx.searchEstabelecimentos()),
                              delay: 0,
                              minimumCharactersToShowList: 0,
                              listValues: 
                      _ctx.estabelecimentosAutoComplete.map(({ estabelecimentoComercialCnpj, estabelecimentoRazaoSocial}) => {
                        return {
                          primaryText: estabelecimentoRazaoSocial,
                          secondaryText: `${
                            estabelecimentoComercialCnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
                          } | ${estabelecimentoRazaoSocial}`,
                          id: estabelecimentoComercialCnpj,
                        };
                      })
                    ,
                              inputEvent: "update:input",
                              resultEvent: "update:select",
                              "onUpdate:input": _ctx.updateSearchEstabelecimentoText,
                              "onUpdate:select": _ctx.handleEstabelecimento
                            }, null, 8, ["searchValue", "searchFunction", "listValues", "onUpdate:input", "onUpdate:select"])
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_CustomInput, {
                              label: "Data inicial",
                              type: "date",
                              name: "startFilter",
                              validation: _ctx.filterDateStartErrorMessage,
                              value: _ctx.startFilter,
                              onChange: _ctx.changeFilterDate,
                              class: "col-span-6"
                            }, null, 8, ["validation", "value", "onChange"]),
                            _createVNode(_component_CustomInput, {
                              label: "Data final",
                              type: "date",
                              name: "endFilter",
                              validation: _ctx.filterDateEndErrorMessage,
                              value: _ctx.endFilter,
                              onChange: _ctx.changeFilterDate,
                              class: "col-span-6"
                            }, null, 8, ["validation", "value", "onChange"])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_PrimaryButton, {
                              label: "Filtrar",
                              type: "button",
                              icon: _ctx.buttonIcons.search.icon,
                              iconCustomClass: "text-white",
                              width: "w-full",
                              class: "col-span-12",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getData()))
                            }, null, 8, ["icon"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_Form, { class: "mt-1 !space-y-0" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_CustomInputAutocomplete, {
                        label: "Estabelecimentos",
                        class: "col-span-12",
                        searchValue: _ctx.searchEstabelecimentoText,
                        searchFunction: () => (_ctx.estabelecimentosAutoComplete = _ctx.searchEstabelecimentos()),
                        delay: 0,
                        minimumCharactersToShowList: 0,
                        listValues: 
                    _ctx.estabelecimentosAutoComplete.map(({ estabelecimentoComercialCnpj, estabelecimentoRazaoSocial}) => {
                      return {
                        primaryText: estabelecimentoRazaoSocial,
                        secondaryText: `${
                          estabelecimentoComercialCnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
                        } | ${estabelecimentoRazaoSocial}`,
                        id: estabelecimentoComercialCnpj,
                      };
                    })
                  ,
                        inputEvent: "update:input",
                        resultEvent: "update:select",
                        "onUpdate:input": _ctx.updateSearchEstabelecimentoText,
                        "onUpdate:select": _ctx.handleEstabelecimento
                      }, null, 8, ["searchValue", "searchFunction", "listValues", "onUpdate:input", "onUpdate:select"])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_CustomInput, {
                        label: "Data inicial",
                        type: "date",
                        name: "startFilter",
                        validation: _ctx.filterDateStartErrorMessage,
                        value: _ctx.startFilter,
                        onChange: _ctx.changeFilterDate,
                        class: "col-span-6"
                      }, null, 8, ["validation", "value", "onChange"]),
                      _createVNode(_component_CustomInput, {
                        label: "Data final",
                        type: "date",
                        name: "endFilter",
                        validation: _ctx.filterDateEndErrorMessage,
                        value: _ctx.endFilter,
                        onChange: _ctx.changeFilterDate,
                        class: "col-span-6"
                      }, null, 8, ["validation", "value", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_PrimaryButton, {
                        label: "Filtrar",
                        type: "button",
                        icon: _ctx.buttonIcons.search.icon,
                        iconCustomClass: "text-white",
                        width: "w-full",
                        class: "col-span-12",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getData()))
                      }, null, 8, ["icon"])
                    ])
                  ])
                ]),
                _: 1
              })
            ])),
        (!_ctx.firstLoading && !_ctx.loading && (!_ctx.isRoot || _ctx.softwareHouseSelected))
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_Card, {
                  class: "col-span-12 md:col-span-4 xl:col-span-2 h-40 flex items-center",
                  orientation: "flex-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_FontAwesomeIcon, {
                          class: "w-6 h-6 rounded-full mx-4 self-center",
                          icon: _ctx.shopIcon
                        }, null, 8, ["icon"]),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(Intl.NumberFormat('pt-br', { currency: 'BRL' }).format(_ctx.estabelecimentosQuantity)), 1)
                      ]),
                      _hoisted_23
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Card, {
                  class: "col-span-12 md:col-span-4 xl:col-span-2 h-40 flex items-center",
                  orientation: "flex-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_FontAwesomeIcon, {
                          class: "w-6 h-6 rounded-full mx-4 self-center",
                          icon: _ctx.fileDollarIcon
                        }, null, 8, ["icon"]),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(Intl.NumberFormat('pt-br', { currency: 'BRL' }).format(_ctx.transactionsQuantity)), 1)
                      ]),
                      _hoisted_28
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Card, {
                  class: "col-span-12 md:col-span-4 xl:col-span-2 h-40 flex items-center",
                  orientation: "flex-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_FontAwesomeIcon, {
                          class: "w-6 h-6 rounded-full mx-4 self-center",
                          icon: _ctx.brazilianRealSign
                        }, null, 8, ["icon"]),
                        _createElementVNode("span", _hoisted_32, _toDisplayString(Intl.NumberFormat('pt-br', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(_ctx.revenueValue)), 1)
                      ]),
                      _hoisted_33
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Card, {
                  class: "col-span-12 md:col-span-4 xl:col-span-2 h-40 flex items-center",
                  orientation: "flex-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_FontAwesomeIcon, {
                          class: "w-6 h-6 rounded-full mx-4 self-center",
                          icon: _ctx.brazilianRealSign
                        }, null, 8, ["icon"]),
                        _createElementVNode("span", _hoisted_37, _toDisplayString(Intl.NumberFormat('pt-br', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(_ctx.expenseValue)), 1)
                      ]),
                      _hoisted_38
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Card, {
                  class: "col-span-12 md:col-span-4 xl:col-span-2 h-40 flex items-center",
                  orientation: "flex-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("div", _hoisted_41, [
                        _createVNode(_component_FontAwesomeIcon, {
                          class: "w-6 h-6 rounded-full mx-4 self-center",
                          icon: _ctx.brazilianRealSign
                        }, null, 8, ["icon"]),
                        _createElementVNode("span", _hoisted_42, _toDisplayString(Intl.NumberFormat('pt-br', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(_ctx.balanceValue)), 1)
                      ]),
                      _hoisted_43
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      (_openBlock(), _createBlock(_component_Table, {
                        columns: _ctx.isRoot ?
                    ['Cnpj', 'Razão Social', 'Software House', 'Transações', 'Valor Total', 'Saldo SoftwareHouse', 'Taxa atual da EC *', 'Taxa atual da SH *', 'Resultado'] :
                    ['Cnpj', 'Razão Social', 'Transações', 'Total de Taxa da EC', 'Total de Taxa da SH', 'Taxa atual da EC *', 'Taxa atual da SH *', 'Resultado'],
                        values: () => _ctx.estabelecimentos.map(({ estabelecimentoComercialCnpj, estabelecimentoRazaoSocial, quantidade, valorTotalTaxaSh, softwareHouseRazaoSocial, taxaMediacao, taxaNegociada, valorTotalTaxaCompany }) => {
                      const resultado = valorTotalTaxaCompany - valorTotalTaxaSh
                      if (_ctx.isRoot) {
                        return {
                          estabelecimentoComercialCnpj: _ctx.formatCnpj(estabelecimentoComercialCnpj),
                          estabelecimentoRazaoSocial,
                          softwareHouseRazaoSocial,
                          quantidade: Intl.NumberFormat('pt-br', { currency: 'BRL' }).format(quantidade),
                          valorTotalTaxaCompany: Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valorTotalTaxaCompany),
                          valorTotalTaxaSh: Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valorTotalTaxaSh),
                          taxaMediacao: Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(taxaMediacao),
                          taxaNegociada: Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(taxaNegociada),
                          resultado: Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(resultado)
                        }
                      } else {
                        return {
                          estabelecimentoComercialCnpj: _ctx.formatCnpj(estabelecimentoComercialCnpj),
                          estabelecimentoRazaoSocial,
                          quantidade: Intl.NumberFormat('pt-br', { currency: 'BRL' }).format(quantidade),
                          valorTotalTaxaCompany: Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valorTotalTaxaCompany),
                          valorTotalTaxaSh: Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valorTotalTaxaSh),
                          taxaMediacao: Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(taxaMediacao),
                          taxaNegociada: Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(taxaNegociada),
                          resultado: Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(resultado)
                        }
                      }
                    }),
                        key: JSON.stringify(_ctx.estabelecimentos),
                        tableId: "volumetria",
                        optionsColumn: false
                      }, null, 8, ["columns", "values"])),
                      (!_ctx.loading && !_ctx.firstLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_50))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              (!_ctx.firstLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _createVNode(_component_PrimaryButton, {
                      width: "w-48 -lg:w-full",
                      label: "Exportar dados",
                      onClick: _cache[2] || (_cache[2] = () => _ctx.reportModal = true),
                      disabled: !_ctx.estabelecimentos || !_ctx.estabelecimentos.length,
                      style: _normalizeStyle({ cursor: !_ctx.estabelecimentos || !_ctx.estabelecimentos.length ? 'not-allowed' : 'pointer' })
                    }, null, 8, ["disabled", "style"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_ctx.loading || _ctx.firstLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_54))
            : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      id: "overlay",
      class: _normalizeClass(["fade-in", _ctx.reportModal ? 'block' : 'hidden fade-out'])
    }, [
      _createElementVNode("div", {
        class: "h-screen flex flex-row overflow-y-scroll p-64",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.reportModal = false), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _createElementVNode("p", _hoisted_57, "Você está solicitando a geração do relatório de volumetria dos estabelecimentos da sua software house no período de " + _toDisplayString(_ctx.startFilter ? _ctx.formatDate(_ctx.startFilter, 'dd/MM/yyyy') : '') + " até " + _toDisplayString(_ctx.endFilter ? _ctx.formatDate(_ctx.endFilter, 'dd/MM/yyyy') : '') + ".", 1),
          _hoisted_58,
          (_openBlock(), _createBlock(_component_Select, {
            label: "Tipo de relatório",
            options: () => _ctx.reportTypeOptions,
            key: _ctx.reportTypeSelected.key,
            selected: _ctx.reportTypeSelected.value,
            display: "value",
            class: "mt-3 w-1/2 -lg:w-full",
            event: "update:select",
            "onUpdate:select": _ctx.handleReportType
          }, null, 8, ["options", "selected", "onUpdate:select"])),
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_component_PrimaryButton, {
              label: "Gerar relatório",
              onClick: _ctx.generateReport,
              iconCustomClass: "text-white",
              class: "ml-2",
              width: "w-48 -lg:w-full",
              type: "submit"
            }, null, 8, ["onClick"])
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      id: "toast-block",
      hidden: _ctx.hidden,
      onHide: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.hide()), ["self"]))
    }, [
      _createVNode(_component_Toast, {
        label: _ctx.message,
        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.hide()), ["self"])),
        success: _ctx.toastSuccess,
        onHide: _ctx.hide
      }, null, 8, ["label", "success", "onHide"])
    ], 40, _hoisted_60)
  ]))
}